import FilteredContactList from './FilteredContactList';

const entity = new FilteredContactList('billingStudents');

export {entity};